import { I18nComponente } from "@/types/gerais"

export const OTabelaUsuariosAtivosi18n: I18nComponente = {
  "pt-BR": {
    nome: "nome",
    codigo: "código",
    perfilDeOrganizacao: "perfil de organização",
    pesquisarPorNomeDoUsuario: "pesquisar por nome do usuário",
    pesquisarporCodigo: "pesquisar por código",
    pesquisarPorPerfisDeOperacao: "pesquisar por perfis de operação",
    limpar: "Limpar",
    aplicar: "Aplicar",
    editar: "editar",
    desativar: "desativar",
    administrador: "administrador",
    supervisor: "supervisor",
    gerente: "gerente",

    pessoal: "pessoal",
    visualizador: "visualizador",
    umUsuarioDesativadoNaoPoderaMaisSerUtilizado: "um usuário desativado não poderá mais ser utilizado para acessar o sistema",

  },
  "es-CO": {
    nome: "nombre",
    codigo: "código",
    perfilDeOrganizacao: "perfil de organización",
    pesquisarPorNomeDoUsuario: "buscar por nombre de usuario",
    pesquisarporCodigo: "buscar por código",
    pesquisarPorPerfisDeOperacao: "buscar por perfiles de operación",
    limpar: "Borrar",
    aplicar: "Aplicar",
    editar: "editar",
    desativar: "desactivar",
    administrador: "administrador",
    supervisor: "supervisor",
    gerente: "gerente",

    pessoal: "personal",
    visualizador: "visualizador",
    umUsuarioDesativadoNaoPoderaMaisSerUtilizado: "un usuario desactivado no podrá ser utilizado para acceder al sistema",
  }
}
